<template>
  <div class="register-hh">
    <div class="step1">
      <van-cell-group>
        <van-field v-if="!inviteCodeRoot" v-model="form.inviteCode" label="邀请码" placeholder="请输入猎企邀请码" />
        <van-field
          v-model="form.mobilePhone"
          :readonly="inviteCodeRoot?true:false"
          label="手机号"
          placeholder="请输入手机号"
        />
        <van-field v-model="form.imageVerifyCode" :maxlength="8" label="图形验证码" placeholder="请输入验证码">
          <div slot="right-icon" class="pic-code">
            <img
              :src="'/hd-weixin/api/v1/user/registers/imageVerifyCode?v=' + vCode"
              @click="changeVcode"
              alt
            />
            <span @click="changeVcode">换一换</span>
          </div>
        </van-field>
        <van-field v-model="form.smsVerifyCode" :maxlength="8" label="手机验证码" placeholder="请输入验证码">
          <div slot="right-icon" class="tel-code">
            <span v-if="!isSendSms" @click="getSmsCode">获取验证码</span>
            <span v-if="isSendSms" style="color:#999">{{sendNum}}秒后重新获取</span>
          </div>
        </van-field>
        <van-field v-model="password" type="password" label="设置密码" placeholder="请输入密码" />
        <van-field v-model="confirmPassword" type="password" label="确认密码" placeholder="请确认密码" />
        <van-field v-model="form.userName" label="姓名" placeholder="请填写姓名" />
        <van-field
          v-model="gender"
          clickable
          readonly
          label="性别"
          @click="showPickerGender = true"
          placeholder="请选择性别"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field
          v-model="workYear"
          clickable
          readonly
          label="工作年份"
          @click="showPickerYear = true"
          placeholder="请选开始工作年份"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field
          v-model="hhTitle"
          clickable
          readonly
          label="猎头头衔"
          @click="showPickerTitle = true"
          placeholder="请选择猎头头衔"
        >
          <span slot="right-icon">
            <van-icon name="arrow" />
          </span>
        </van-field>
        <van-field v-model="form.email" label="联系邮箱" placeholder="请输入邮箱" />
        <van-cell>
          <p class="reg-tips">
            点击立即注册代表您已经同意
            <span @click="showPop">《猎上用户协议》</span>
          </p>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="btns">
      <van-button type="primary" @click="submit">立即注册</van-button>
    </div>
    <!-- 用户协议 -->
    <van-popup v-model="show" position="bottom" :lazy-render="false" class="agreement-pop">
      <div class="pop-up-wrap">
        <div class="pop-inner">
          <protocol></protocol>
        </div>
      </div>
    </van-popup>
    <div class="pop-btn" v-if="show" @click="show = false">取消</div>

    <!-- 性别 -->
    <van-popup v-model="showPickerGender" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsGender"
        @cancel="showPickerGender = false"
        @confirm="onConfirmGender"
      />
    </van-popup>
    <!-- 工作年份 -->
    <van-popup v-model="showPickerYear" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        :columns="columnsYear"
        @cancel="showPickerYear = false"
        @confirm="onConfirmYear"
      />
    </van-popup>
    <!-- 猎头头衔 -->
    <van-popup v-model="showPickerTitle" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="columnsHH"
        @cancel="showPickerTitle = false"
        @confirm="onConfirmTitle"
      />
    </van-popup>
  </div>
</template>
<style lang="scss" scoped>
.register-hh {
  // 隐藏最上方1px边框
  margin-top: -1px;
  padding-bottom: 30px;
  .pic-code,
  .tel-code {
    position: relative;
    img {
      position: relative;
      top: -2px;
      right: 5px;
      display: inline-block;
      width: 50px;
      height: 28px;
      background: #f5f5f5;
    }
    span {
      color: #22baa5;
      font-size: 14px;
    }
  }
  .reg-tips {
    color: #666;
    span {
      color: #22baa5;
    }
  }

  .btns {
    .van-button {
      width: 100%;
      font-size: 16px;
    }
    padding: 0 15px;
    margin-top: 20px;
  }

  .pop-up-wrap {
    height: 100%;
    overflow: auto;
    .pop-inner {
      background: #fff;
      padding-bottom: 55px;
    }
    
  }
  .pop-btn {
      position: fixed;
      bottom: 0;
      height: 50px;
      line-height: 45px;
      background: #fff;
      width: 100%;
      border-top: 5px solid #f5f5f5;
      text-align: center;
      font-size: 16px;
      z-index: 999999;
    }
}
</style>
<style lang="scss">
.register-hh {
  .van-cell-group {
    input {
      font-size: 16px;
    }
  }
  .van-field {
    padding-top: 15px;
    span {
      font-size: 16px;
    }
  }
  .agreement-pop {
    height: 60%;
    background: #f5f5f5;
  }
}
</style>
<script>
import { range } from "@/common/utils";

import { isMobile, isEmail } from "@/common/utils";

import { getLink , login, sendRegSms, uploadCompanyImage , joinCompany ,registerUser , uploadAvatar , getUserAuthenticationView , getCompanyInfoByInviteCode} from "@/api/account";

import md5 from 'md5'

import protocol from "./protocol";

// 若是root注册 不显示邀请码，手机号不能改 isroot && mobile
export default {
  name: "register-hh-module",
  data() {
    return {
      unionId:this.$route.query.unionId || '',
      show: false,
      step: 1,
      isSendSms: false,
      sendNum: 60,
      vCode: new Date().getTime(),
      root: this.$route.query.root || "",
      showPickerGender: false,
      showPickerYear: false,
      showPickerTitle: false,
      columnsGender: [{ id: 1, name: "男" }, { id: 2, name: "女" }],
      columnsYear: range(
        new Date().getFullYear(),
        new Date().getFullYear() - 30,
        -1
      ),
      columnsHH: [
        { id: "1", name: "寻访员（R）" },
        { id: "2", name: "助理顾问（AC）" },
        { id: "3", name: "顾问（C）" },
        { id: "4", name: "资深顾问（SC）" },
        { id: "5", name: "合伙人" },
        { id: "7", name: "其他" }
      ],
      gender: "",
      workYear: "",
      hhTitle: "",
      password: "",
      confirmPassword: "",
      inviteCodeRoot: this.$route.query.inviteCode || "",
      form: {
        inviteCode: this.$route.query.inviteCode || "",
        mobilePhone: "",
        imageVerifyCode: "",
        smsVerifyCode: "",
        password: "",
        confirmPassword: "",
        userName: "",
        gender: "",
        beginWorkYear: "",
        title: "",
        email: "",
        confirm: true
      },
      certForm:{
        imgUrl:'',
        avatarUrl:''
      }
    };
  },
  watch: {

  },
  components: {
    protocol
  },
  methods: {
    getSmsCode() {
      if (!this.checkMobile()) return;

      sendRegSms({
        mobilePhone: this.form.mobilePhone,
        imageVerifyCode: this.form.imageVerifyCode
      })
        .then(res => {
          this.countDown();
        })
        .catch(err => {
          this.changeVcode();
        });

    },
    checkRegInfo() {
      if (!this.form.inviteCode.trim()) {
        this.$toast("请填写邀请码");
        return;
      }
      if (!this.checkMobile()) {
        return;
      }
      if (!this.form.smsVerifyCode.trim()) {
        this.$toast("请填写手机验证码");
        return;
      }

      if (!this.password.trim()) {
        this.$toast("请填写密码");
        return;
      }
      if (!this.confirmPassword.trim()) {
        this.$toast("请确认密码");
        return;
      }
      if (this.password.trim() != this.confirmPassword.trim()) {
        this.$toast("密码不一致");
        return;
      }
      if (!this.form.userName.trim()) {
        this.$toast("请填写姓名");
        return;
      }
      if (!this.form.gender) {
        this.$toast("请选择性别");
        return;
      }
      if (!this.form.beginWorkYear) {
        this.$toast("请选择工作年份");
        return;
      }
      if (!this.form.title) {
        this.$toast("请选择猎头头衔");
        return;
      }
      // 邮箱
      if (!this.form.email.trim()) {
        this.$toast("请填写邮箱");
        return;
      }
      console.log(isEmail(this.form.email.trim()));
      if (!isEmail(this.form.email.trim())) {
        this.$toast("邮箱格式不正确");
        return;
      }

      return true;
    },
    checkMobile() {
      if (!this.form.mobilePhone.trim()) {
        this.$toast("请填写手机号");
        return;
      }
      if (!isMobile(this.form.mobilePhone.trim())) {
        this.$toast("手机号格式不正确");
        return;
      }

      if (!this.form.imageVerifyCode.trim()) {
        this.$toast("请输入验证码");
        return;
      }
      return true;
    },
    countDown() {
      this.isSendSms = true;
      let timer = null;
      let fn = () => {
        clearTimeout(timer);
        if (this.sendNum <= 1) {
          timer = null;
          this.isSendSms = false;
          this.sendNum = 60;
          return;
        }
        this.sendNum--;

        timer = setTimeout(fn, 1000);
      };
      timer = setTimeout(fn, 1000);
    },
    onConfirmTitle(item) {
      this.hhTitle = item.name;
      this.form.title = item.id;
      this.showPickerTitle = false;
    },
    onConfirmGender(item) {
      this.gender = item.name;
      this.form.gender = item.id;
      this.showPickerGender = false;
    },
    onConfirmYear(item) {
      this.workYear = item;
      this.form.beginWorkYear = item;
      this.showPickerYear = false;
    },
    changeVcode() {
      this.vCode = new Date().getTime();
    },
    showPop() {
      this.show = true;
    },
    getLoginParams(link){
      const {nonce, randomToken, realm} = link.data;
      const username = this.form.mobilePhone.trim();
      const password = md5(this.password.trim());
      const password2 = md5(password + '5OGP56W65A6D6LSD') + 'x';

      function getAuthorizeCode(input) {
        const ha1 = md5(`${username || ''}:${realm}:${input}`);
        const ha2 = md5('POST:/v1/user/logins/login');
        return md5(`${ha1}:${nonce}:${ha2}`);
      }

      let logparams = {
        loginName: username,
        authorizeCode: getAuthorizeCode(password),
        twoAuthorizeCode: getAuthorizeCode(password2)
        //unionId:this.unionId
      };
      return logparams;
    },
    autoLogin(){
      // unionId
      getLink().then(link => {
        let params = this.getLoginParams(link);
        login(params).then(res=>{
          
          this.$router.push({path:'/account/certification'});
        }).catch( err => {
          
        })
      });
      
    },
    submit() {
      
      if (this.checkRegInfo()) {
        this.form.password = md5(this.password);
        this.form.confirmPassword = md5(this.confirmPassword);
        if(this.inviteCodeRoot){
          //root 点链接进来注册 
          registerUser(this.form).then(res=>{
            console.log('root - root');
            this.autoLogin();
          }).catch(err => {

          });
        }else{
          joinCompany(this.form).then(res=>{
            console.log('root - hh');
            this.autoLogin();
          }).catch(err => {

          });
        };
      }


    }
  },
  created() {

    // if(!this.unionId){ 注册不需要了
    //   window.location.href= window.location.origin + '/hd-weixin/api/v1/wechat/authorize?returnUrl=' + window.location.href;
    // };
    if(this.inviteCodeRoot){
        this.form.inviteCode = this.inviteCodeRoot;
        //root 点链接进来注册 获取手机号
        getCompanyInfoByInviteCode({
          companyInviteCode:this.inviteCodeRoot
        }).then( res=> {
          if(res.data.userBaseBean){
            this.form.mobilePhone = res.data.userBaseBean.mobilePhone;
          }
        }).catch( err=>{

        });
    }
  }
};
</script>
